export enum FontSize {
  SMALL,
  MEDIUM,
  LARGE,
}
